import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  VISITOR_EDIT,
  VISITOR_UPDATE,
  CATEGORY_LIST_DROPDOWN,
} from "../../routes/routes";
import { toast } from "react-toastify";
import { VISITOR_UPDATED } from "../../constant/constant";
import Select from "react-select";
import { FullPageLoader } from "../../components/common/Loader";
import { Image } from "react-bootstrap";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import { memberFormSelectStyles } from "../../constant/selectStyles";

const VisitorEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const isInductionFromUrl = location.pathname.includes("/visitors/inductions");
  const isChiefGuestFromUrl = location.pathname.includes("/visitors/chief-guest");
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [categoryOptions, setCategoryOptions] = useState([]);

  const visitorTypeOptions = [
    { value: 0, label: "General" },
    { value: 1, label: "Chief Guest" },
    { value: 2, label: "Power Date" },
    { value: 3, label: "Inductions" },
  ];

  let currentTypeSlug = "general";
  if (location.pathname.includes("/visitors/chief-guest")) currentTypeSlug = "chief-guest";
  else if (location.pathname.includes("/visitors/power-date")) currentTypeSlug = "power-date";
  else if (location.pathname.includes("/visitors/inductions")) currentTypeSlug = "inductions";

  const listPath = `/visitors/${currentTypeSlug}`;
  const listLabel =
    {
      general: "General",
      "chief-guest": "Chief Guest",
      "power-date": "Power Date",
      inductions: "Inductions",
    }[currentTypeSlug] || "Visitors";

  const submit = () => {
    setLoading(true);
    setBtnDisabled(true);
    const requestBody = {
      ...form,
      visit_date: moment(form.visit_date, [
        "YYYY-MM-DD",
        "DD/MM/YYYY",
      ]).format("YYYY-MM-DD"),
      category_id: Number(form.visitor_type) === 3 ? form.category_id : null,
    };
    axios
      .put(VISITOR_UPDATE + id, requestBody, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(VISITOR_UPDATED);
          navigate(listPath);
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          setErrors(err.response.data.error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    axios
      .get(VISITOR_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const d = res.data.data;
          const isInductionType = isInductionFromUrl || Number(d.visitor_type) === 3;
          setForm({
            visit_date: moment(d.visit_date, [
              "DD/MM/YYYY",
              "YYYY-MM-DD",
            ]).format("YYYY-MM-DD"),
            visitor_type: isInductionType ? 3 : d.visitor_type,
            visitor_type_selected: isInductionType
              ? { value: 3, label: "Inductions" }
              : visitorTypeOptions.find(
                  (o) => o.value === Number(d.visitor_type),
                ) || null,
            category_id: d.category_id || "",
            category_selected: d.category_id
              ? {
                  value: Number(d.category_id),
                  label: d.category_name,
                }
              : null,
            visitor_name: d.visitor_name || "",
            visitor_company_name: d.visitor_company_name || "",
            visitor_phone: d.visitor_phone || "",
            visitor_email: d.visitor_email || "",
            visitor_address: d.visitor_address || "",
            comments: d.comments || "",
            cardImage: d.image || "",
            user_name: d.user_name || "",
          });
        }
      })
      .finally(() => setLoading(false));

    axios.get(CATEGORY_LIST_DROPDOWN).then((res) => {
      if (res.status === 200 && res.data.success) {
        setCategoryOptions(res.data.data || []);
      }
    });
  }, [id]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <h5 className="page-title">Visitors - {listLabel}</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={listPath}>
                    <span>Visitors {listLabel} List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Edit Visitor</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={listPath}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body app-form-fields">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="user_name">
                          Host Member
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="user_name"
                          value={form.user_name || ""}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="visit_date">
                          Visit Date<span className="text-danger">*</span>
                        </label>
                        <Flatpickr
                          id="visit_date"
                          className="form-control"
                          placeholder="Select Date"
                          value={form.visit_date || ""}
                          options={{ dateFormat: "Y-m-d" }}
                          onChange={(dates) =>
                            setForm({
                              ...form,
                              visit_date: dates[0]
                                ? moment(dates[0]).format("YYYY-MM-DD")
                                : "",
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="visit_date" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="visitor_type">
                          Visitor Type<span className="text-danger">*</span>
                        </label>
                        <Select styles={memberFormSelectStyles}
                          name="visitor_type"
                          isDisabled={
                            form.visitor_type_selected === 1
                          }
                          options={visitorTypeOptions}
                          placeholder="Select"
                          value={form.visitor_type_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              visitor_type: selected?.value,
                              visitor_type_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="visitor_type" />
                      </div>
                    </div>
                    {Number(form.visitor_type) === 3 && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="category_id">
                            Category<span className="text-danger">*</span>
                          </label>
                          <Select styles={memberFormSelectStyles}
                            name="category_id"
                            options={categoryOptions}
                            placeholder="Select Category"
                            value={form.category_selected || null}
                            onChange={(selected) =>
                              setForm({
                                ...form,
                                category_id: selected?.value,
                                category_selected: selected,
                              })
                            }
                          />
                          <ValidationMessage error={errors} name="category_id" />
                        </div>
                      </div>
                    )}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="visitor_name">
                          Visitor Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="visitor_name"
                          placeholder="Visitor Name"
                          value={form.visitor_name || ""}
                          onChange={(e) =>
                            setForm({ ...form, visitor_name: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="visitor_name" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="visitor_company_name"
                        >
                          Company<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="visitor_company_name"
                          placeholder="Company"
                          value={form.visitor_company_name || ""}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              visitor_company_name: e.target.value,
                            })
                          }
                        />
                        <ValidationMessage
                          error={errors}
                          name="visitor_company_name"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="visitor_phone">
                          Phone<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="visitor_phone"
                          placeholder="Phone"
                          value={form.visitor_phone || ""}
                          onChange={(e) =>
                            setForm({ ...form, visitor_phone: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="visitor_phone" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="visitor_email">
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="visitor_email"
                          placeholder="Email"
                          value={form.visitor_email || ""}
                          onChange={(e) =>
                            setForm({ ...form, visitor_email: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="visitor_address">
                          Address
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="visitor_address"
                          placeholder="Address"
                          value={form.visitor_address || ""}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              visitor_address: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="comments">
                          Comments
                        </label>
                        <textarea
                          className="form-control"
                          id="comments"
                          placeholder="Comments"
                          rows={3}
                          value={form.comments || ""}
                          onChange={(e) =>
                            setForm({ ...form, comments: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="image">
                          Image
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          id="image"
                          accept="image/*"
                          onChange={(e) =>
                            setForm({ ...form, image: e.target.files?.[0] })
                          }
                        />
                        {form.cardImage && (
                          <Image
                            src={form.cardImage}
                            width={100}
                            className="mt-2"
                          />
                        )}
                      </div>
                    </div> */}

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={listPath}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="button"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisitorEdit;
